import { ADD_CLIENT,ADD_CLIENT_SUCCESS, ADD_CLIENT_FAIL, UPDATE_CLIENT_LOADING, UPDATE_CLIENT, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAIL} from "./actionType";

export const DataNew= (user, history, id) => {
    return {
      type: ADD_CLIENT,
      payload: { user, history, id},
    }
  }
  
  export const addNewClientSuccess = user => {
    return {
      type: ADD_CLIENT_SUCCESS,
      payload: user,
    }
  }
  export const addNewClientError = error => {
    return {
      type: ADD_CLIENT_FAIL,
      payload: error,
    }
  }
  export const updateClient = id => (
    {
    type: UPDATE_CLIENT,
    payload: id,
  })
  
  export const updateClientSuccess = user => {
    return{
      type: UPDATE_CLIENT_SUCCESS,
      payload: user
    }
  }
  export const updateClientsLoading= (loading) =>({
    type: UPDATE_CLIENT_LOADING,
    payload: loading
})
  export const updateClientFail = error => ({
    type: UPDATE_CLIENT_FAIL,
    payload: error,
  })